module.exports = __webpack_public_path__ + "card-VC.png?9a3000bec6d8e1419355c42fc0049f59";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/card-VC.png
// module id = 201
// module chunks = 0